import styled from 'styled-components';
import {
  defaultColor, font, radius, spacing,
} from 'styles/theme';

export const Notice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacing('small')};
  margin: ${spacing('medium')} 0;
  padding: ${spacing('small')} ${spacing('medium')};
  background: ${defaultColor('green', 0.1)};
  border: 1px solid ${defaultColor('green', 0.3)};
  border-radius: ${radius('small')};
  color: ${defaultColor('dark')};
`;

export const Icon = styled.div`
  flex: none;
  width: 22px;
  margin-top: 1px;
  color: ${defaultColor('greenDark')};

  svg {
    display: block;
    width: 22px;
    height: 20px;
  }

  svg path {
    fill: currentColor;
  }
`;

export const Title = styled.div`
  font-family: ${font('semibold')};
  font-size: 14px;
  line-height: 20px;
`;

export const Hint = styled.div`
  margin-top: 2px;
  font-family: ${font('regular')};
  font-size: 13px;
  line-height: 18px;
`;
